import { StateProvider } from '@uirouter/angularjs';

export default function($stateProvider: StateProvider) {
  'ngInject';

  $stateProvider.state('login', {
    component: 'login',
    params: {
      transition: {
        inherit: false,
        value: null
      }
    },
    parent: 'app',
    url: '/login'
  });

  $stateProvider.state('mobileconnect', {
    component: 'mobileConnectCallback',
    parent: 'app',
    url: '/mobileconnect?code&check&error&state'
  });
}



// WEBPACK FOOTER //
// ./src/app/login/login.routes.ts